import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-password",
  "use": "icon-password-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" id=\"icon-password\">\n<style type=\"text/css\">\n\t#icon-password .st0{fill:rgba(55, 123, 255, 1);}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M38.5,17h-0.6C37.4,10.3,31.4,5,24,5s-13.4,5.3-13.9,12H9.5C7,17,5,19,5,21.5v17C5,41,7,43,9.5,43h29\n\t\tc2.5,0,4.5-2,4.5-4.5v-17C43,19,41,17,38.5,17z M24,8c5.7,0,10.4,4,10.9,9H13.1C13.6,12,18.3,8,24,8z M40,38.5\n\t\tc0,0.8-0.7,1.5-1.5,1.5h-29C8.7,40,8,39.3,8,38.5v-17C8,20.7,8.7,20,9.5,20h29c0.8,0,1.5,0.7,1.5,1.5V38.5z\" />\n\t<path class=\"st0\" d=\"M24,27c-0.8,0-1.5,0.7-1.5,1.5v8c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5v-8C25.5,27.7,24.8,27,24,27z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcons/svg/password.svg
// module id = mjfm
// module chunks = 35